import { render, staticRenderFns } from "./APICatalogue.vue?vue&type=template&id=769a8bb4&"
import script from "./APICatalogue.vue?vue&type=script&lang=js&"
export * from "./APICatalogue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports